import React, { PureComponent } from 'react'

class Loader extends PureComponent {
    loader = () => (
        <div id="overlay">
            <div
                className="loader"
                style={{
                    color: 'rgba(57,183,183, 1)',
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                }}
            />
        </div>
    )

    render() {
        const { show } = this.props
        return (
            show && (this.loader())
        )
    }
}

export default Loader
